import {
  BarChart3,
  FolderKanban,
  Home,
  ListChecks,
  TriangleAlert,
  Users,
  type LucideIcon,
} from 'lucide-react';

export interface NavItemDefinition {
  to: string;
  label: string;
  icon: LucideIcon;
  /** Matches nested routes, e.g. /projects/prj_1 highlights "Proyectos". */
  matchPrefix?: boolean;
  /** Renders the live count pill, as in the design. */
  showAttentionCount?: boolean;
}

/** Primary navigation, in the order fixed by the design. */
export const NAV_ITEMS: readonly NavItemDefinition[] = [
  { to: '/', label: 'Inicio', icon: Home },
  { to: '/projects', label: 'Proyectos', icon: FolderKanban, matchPrefix: true },
  { to: '/activities', label: 'Actividades', icon: ListChecks, matchPrefix: true },
  {
    to: '/attention',
    label: 'Riesgos y bloqueos',
    icon: TriangleAlert,
    matchPrefix: true,
    showAttentionCount: true,
  },
  { to: '/reports', label: 'Reportes', icon: BarChart3, matchPrefix: true },
  { to: '/team', label: 'Equipo', icon: Users, matchPrefix: true },
];
